import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    this.updateSidebarState()
  }

  inputTargetConnected() {
    this.inputTarget.addEventListener("change", this.updateSidebarState.bind(this))
  }

  inputTargetDisconnected() {
    this.inputTarget.removeEventListener("change", this.updateSidebarState.bind(this))
  }

  updateSidebarState() {
    if (this.hasInputTarget) {
      const isOpen = this.inputTarget.checked

      if (isOpen) {
        this.element.dataset.sidebarOpen = "true"
      } else {
        this.element.dataset.sidebarOpen = "false"
      }
    }
  }
}
